module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('br')], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.specList,
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "100px"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewQuote(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("view_quilt")])])]), _vm._v(" "), _vm._l((_vm.objQuoteSettings), function(item) {
          return (item.checked) ? _c('td', {
            staticClass: "text-xs-right",
            attrs: {
              "width": _vm.fncGetWidth(item.id)
            }
          }, [(item.id == 'status') ? _c('a', {
            attrs: {
              "href": "#"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncEditStatusPopup(props.item, props.item.id)
              }
            }
          }, [_c('i', {
            staticClass: "material-icons"
          }, [_vm._v("edit")])]) : _vm._e(), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncFormatColumn(props.item, item.id))
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncEditStatus(props.item, item.id)
              }
            }
          })]) : _vm._e()
        }), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "100px"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncForex(props.item.id, props.item.quote_no, props.item.override_currency_code)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("attach_money")])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "100px"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncQuoteSettings(props.item.id, props.item.quote_no)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("settings")])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "100px"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDistibuteQuote(props.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("message")])])])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}